// extracted by css-extract-rspack-plugin
export default {"onboardingAppWrapper":"src-modules-app-registry-components-OnboardingApp-OnboardingApp-module__onboardingAppWrapper-FUZeKh"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"onboardingAppWrapper\":\"src-modules-app-registry-components-OnboardingApp-OnboardingApp-module__onboardingAppWrapper-FUZeKh\"}";
        // 1793874319124
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  